<template>
  <div class="c-main">
    <div
      class="banner"
      :style="{
        backgroundImage: `url('${BASE_URL}${productHeader.url}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      }"
    >
      <div class="banner-container">
        <h1 class="banner-title">产品中心</h1>
        <p class="banner-desc" v-html="productHeader.content "></p>
      </div>
      <div class="breadcrumb">
        <span @click="$router.push('/')">首页</span>
        <span class="separator">/</span>
        <span>产品中心</span>
      </div>
    </div>
    <div class="price-image-section" v-if="productPriceImage.list.length">
      <div class="price-tab-wrap">
        <button
          class="price-tab"
          v-for="(item, index) in productPriceImage.list"
          :key="index"
          :class="{ active: activeProductPriceIndex === index }"
          @click="setActiveProductPrice(index)"
        >
          {{ item.tabTitle }}
        </button>
      </div>
      <div class="price-image-content" v-if="activeProductPriceItem">
        <div
          class="price-image-grid"
          v-if="
            activeProductPriceItem.imageUrls &&
            activeProductPriceItem.imageUrls.length
          "
        >
          <div
            class="price-image-cell"
            v-for="(item, index) in activeProductPriceItem.imageUrls"
            :key="index"
          >
            <img :src="BASE_URL + item" alt="" v-if="item" />
          </div>
        </div>
        <button
          class="price-diff-btn"
          v-if="activeProductPriceItem.bigImageUrl"
          @click="toggleProductPriceDiff"
        >
          <span
            class="price-diff-icon"
            :class="{ open: isProductPriceDiffOpen }"
          ></span>
          <span>{{ isProductPriceDiffOpen ? "收起版本差异" : "查看版本差异" }}</span>
        </button>
        <div
          class="price-big-image"
          v-if="activeProductPriceItem.bigImageUrl && isProductPriceDiffOpen"
        >
          <img :src="BASE_URL + activeProductPriceItem.bigImageUrl" alt="" />
        </div>
      </div>
    </div>
    <!-- 产品中心图片描述 -->
    
    <!-- <div class="feature-section">
      <div
        class="feature-item"
        v-for="(module, index) in productContect.list"
        :key="index"
        :class="{ reverse: index % 2 === 1 }"
      >
       
        <div class="feature-text">
          <h3 class="module-title">{{ module.bigTitle }}</h3>
          <ul class="feature-list">
            <li v-for="(item, i) in module.list" :key="i">
              <span class="list-num">{{
                (i + 1).toString().padStart(2, "0")
              }}</span>
              {{ item.title }}
            </li>
          </ul>
          <el-button
            type="primary"
            class="experience-btn"
            @click="goFreeTrial"
          >
            立即体验 <span class="arrow"></span>
          </el-button>
        </div>

        <div class="feature-img">
          <el-carousel indicator-position="outside" arrow="never">
            <el-carousel-item v-for="(item,index) in module.imageUrls" :key="index">
              <img :src="BASE_URL + item" alt="" v-if="item" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import { getConf } from "../../api/article";
// import ArticleItem from "../Components/ArticleItem";


export default {
  name: "productCenter",
  data() {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      productHeader: {},
      productContect: { list: [{ list: [] }] },
      productPriceImage: { list: [] },
      activeProductPriceIndex: 0,
      isProductPriceDiffOpen: false,

    };
  },
  components: {},
  computed: {
    activeProductPriceItem() {
      return this.productPriceImage.list[this.activeProductPriceIndex] || null;
    },
  },
  created() {},
  mounted() {
    this.fetchHomeConf();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.productHeader = JSON.parse(response.data.productHeader) || {};
        this.productContect = JSON.parse(response.data.productContect) || { list: [{ list: [] }] };
        this.productPriceImage = JSON.parse(response.data.productPriceImage) || { list: [] };
        this.activeProductPriceIndex = 0;
        this.isProductPriceDiffOpen = !!(
          this.activeProductPriceItem && this.activeProductPriceItem.bigImageUrl
        );
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
     goFreeTrial() {
      this.$router.push({ name: "freeTrial" });
    },
    setActiveProductPrice(index) {
      this.activeProductPriceIndex = index;
      this.isProductPriceDiffOpen = !!(
        this.activeProductPriceItem && this.activeProductPriceItem.bigImageUrl
      );
    },
    toggleProductPriceDiff() {
      this.isProductPriceDiffOpen = !this.isProductPriceDiffOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.c-main {
  min-height: calc(100vh - 100px);
}
.banner {
  width: 100%;
  height: 450px;
  position: relative;
  .banner-container {
    position: absolute;
    left: 300px; // 距离左侧边距
    top: 177px;
    transform: translateY(-50%);
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .banner-title {
      font-size: 48px;
      font-weight: bold;
      margin: 0 0 20px;
      line-height: 1.2;
    }

    .banner-desc {
      font-size: 16px;
      margin: 0 0 16px;
      opacity: 0.9;
      max-width: 1200px;
    }
  }
  .breadcrumb {
    position: absolute;
    left: 300px; // 距离左侧边距
    bottom: 24px;
    font-size: 12px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    span {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }

    .separator {
      cursor: default;
      opacity: 0.6;
    }
  }
}
.feature-section {
  box-sizing: border-box;
}

// 功能模块项
.feature-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  height: 800px;
  background-color: #ffffff;

  // 偶数项反向排列（图左文右）
  &.reverse {
    flex-direction: row-reverse;
    background-color: #f9fbff;
  }

  // 最后一项去除底部间距
  &:last-child {
    margin-bottom: 0;
  }
}

// 文本内容区
.feature-text {
  width: 450px;

  .module-title {
    font-size: 26px;
    color: #005cef;
    margin: 0 0 24px;
    padding-bottom: 10px;
    border-bottom: 2px solid #005cef;
    font-weight: bold;
  }

  .feature-list {
    list-style: none;
    padding: 0;
    margin: 0 0 30px;

    li {
      font-size: 15px;
      color: #333;
      margin-bottom: 16px;
      line-height: 1.6;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .list-num {
      display: inline-block;
      width: 24px;
      color: #005cef;
      font-weight: bold;
      margin-right: 8px;
    }
  }

  .experience-btn {
    width: 160px;
    height: 48px;
    padding: 9px 28px;
    font-size: 18px;
    display: inline-flex;
    align-items: center;
    background-color: #005cef;
    border-radius: 4px 4px 4px 4px;
    gap: 8px;
    .arrow {
      /* 补充箭头样式（如白色圆圈） */
      width: 16px;
      height: 16px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      margin-left: 8px;
      display: inline-block;
    }
  }
}

// 图片展示区
.feature-img {
  width: 780px;
  height: 440px;
  border-radius: 8px;

  .module-img {
    width: 100%;
    height: 100%;
  }
}

.price-image-section {
  width: 80%;
  margin: 0 auto 80px;
  padding-top: 10px;
}

.price-tab-wrap {
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  min-height: 56px;
  margin: 20px auto;
  padding: 8px;
  overflow-x: auto;
  background: #f0f6ff;
  border-radius: 28px;
  box-shadow: 0 4px 14px rgba(0, 92, 239, 0.1);
}

.price-tab {
  flex: 1 0 144px;
  min-width: 144px;
  height: 40px;
  padding: 0 22px;
  border: 0;
  border-radius: 22px;
  background: transparent;
  color: #111827;
  font-size: 16px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  &.active {
    background: #ffffff;
    color: #005cef;
    box-shadow: 0 4px 12px rgba(0, 92, 239, 0.12);
  }
}

.price-image-content {
  width: 100%;
}

.price-image-grid {
  display: flex;
  gap: 24px;
  width: 100%;
}

.price-image-cell {
  flex: 1;
  min-width: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.price-diff-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 44px;
  min-width: 180px;
  margin: 34px auto 0;
  padding: 0 20px;
  border: 1px solid #005cef;
  border-radius: 22px;
  background: #ffffff;
  color: #005cef;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f0f6ff;
    box-shadow: 0 4px 12px rgba(0, 92, 239, 0.12);
  }
}

.price-diff-icon {
  width: 10px;
  height: 10px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg);
  transition: transform 0.2s ease;

  &.open {
    transform: rotate(225deg);
  }
}

.price-big-image {
  width: 100%;
  margin-top: 32px;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

@media (max-width: 768px) {
  .price-tab-wrap {
    width: 100%;
  }

  .price-tab {
    flex-basis: 120px;
    min-width: 120px;
    font-size: 14px;
  }

  .price-image-grid {
    flex-direction: column;
  }
}
</style>
